import styled from "styled-components";

import { darken } from "polished";
import "../../index.scss";
import "../../styles/sass/Pages/_newDesign.scss";
import google from "../../assets/google.svg";
import facebook from "../../assets/facebook.svg";
import ReactInputMask from "react-input-mask";

export const Container = styled.div`
	display: flex;
	width: 100%;
	height: 100%;
	justify-content: space-between;
	overflow-y: auto;
	flex-direction: row;
	align-items: flex-end;

	@media only screen and (max-width: 900px) {
		flex-direction: column;
		align-items: center;
		overflow-y: unset;
	}

	@media only screen and (max-width: 380px) {
		height: 40rem;
	}
`;

export const Content = styled.section`
	width: 50%;
	height: 100%;
	background: #23242f;
	z-index: 1000;

	display: flex;
	flex-direction: column;
	align-items: center;
	font-family: "MetropolisRegular";

	@media only screen and (max-device-height: 615px) {
		overflow-y: scroll;
	}

	@media only screen and (max-width: 900px) {
		width: 100%;
		background: #13141b;
		position: relative;
		max-width: 23rem;
		justify-content: flex-start;
	}

	@media only screen and (max-width: 380px) {
		width: 85%;
	}

	form {
		width: 100%;
		max-width: 27rem;
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;

		@media only screen and (max-width: 900px) {
			height: unset;
		}
	}
`;

export const ButtonOpenAccount = styled.button`
	display: flex;
	justify-content: center;
	background: transparent;
	color: #01e59b;
	text-decoration: none;
	font-size: 16px;
	width: 100%;
	height: 40px;
	border: 2px solid #01e59b;
	border-radius: 8px;
	align-items: center;
	font-family: var(--font-family-metropolis-semi-bold);
	outline: none !important;

	&:hover {
		color: #01e59b;
		text-decoration: underline;
	}
`;

export const Title = styled.div`
	font-size: 24px;
	color: #ffffff;
	margin-bottom: 20px;
	font-family: var(--font-family-metropolis-semi-bold);

	@media only screen and (max-width: 800px) {
		font-size: 16px;
	}
`;

export const FormGroupInput = styled.div`
	position: relative;
	padding-top: 13px;

	input {
		font-size: 16px;
		color: #ffffff;
		padding: 16px 50px 16px 16px;
		height: 56px;
		width: 100%;
		outline: none;
		z-index: 1;
		background-color: transparent;
		border-radius: 8px;
		font-family: "MetropolisRegular";
	}

	label {
		font-family: var(--font-family-metropolis-semi-bold);
		margin-bottom: 4px;
	}

	.container-password {
		display: flex;
		align-items: center;
	}
`;

export const PasswordEye = styled.div.withConfig({
	shouldForwardProp: (props) => props !== "error",
})`
	cursor: pointer;
	color: ${(props) => (props.error ? "#D30D48" : "#CACED4")};
	position: absolute;
	right: 16px;
	z-index: 1;
`;

export const FormGroupLine = styled.div`
	color: #ffffff;
	margin-top: 16px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	font-size: 16px;

	button {
		background: transparent;
		border: 0;
		color: #01e59b;
		text-decoration: none;
		font-size: 16px;
		font-family: var(--font-family-metropolis-semi-bold);
		outline: none !important;

		&:hover {
			color: #01e59b;
			text-decoration: underline;
		}
	}

	&.right {
		justify-content: flex-end;
	}
`;

export const Group = styled.div`
	cursor: pointer;
	display: flex;
	justify-content: space-between;
	width: 8.5rem;
	align-content: center;
	align-items: center;
	line-height: initial;

	span {
		margin-left: 5px;
		font-size: 16px;
		color: #ffffff;
	}
`;

export const InputCpf = styled(ReactInputMask).withConfig({
	shouldForwardProp: (props) => props !== "error",
})`
	font-family: "MetropolisRegular";
	font-size: 16px;
	border: solid 2px ${(props) => (!props.error.value ? "#353546" : "#D30D48")} !important;

	&:focus {
		border: solid 2px ${(props) => (!props.error.value ? "#01E59B" : "#D30D48")} !important;
	}
`;

export const InputText = styled(ReactInputMask)`
	font-family: "MetropolisRegular";
	font-size: 16px;
	border: solid 2px ${(props) => (!props.error.value ? "#353546" : "#D30D48")} !important;

	&:focus {
		border: solid 2px ${(props) => (!props.error.value ? "#01E59B" : "#D30D48")} !important;
	}
`;

export const Label = styled.label`
	font-size: 12px;
	color: #ffffff;
`;

export const SubmitButtom = styled.button`
	width: 100%;
	margin-top: 40px;
	background-color: #01e59b;
	border-radius: 8px;
	align-self: center;
	color: #13141b;
	padding: 5px;
	border: 0px;
	font-size: 16px;
	height: 40px;
	font-family: var(--font-family-metropolis-semi-bold);
	outline: none !important;

	&:hover {
		background: ${darken(0.03, "#01E59B")};
	}

	&:disabled {
		opacity: 0.24;
	}
`;

export const LoginSocial = styled.span`
	color: #ffffff;
	margin-top: 3rem;
	display: flex;
	flex-direction: row;
	justify-content: center;
	font-size: 16px;
	margin-bottom: 8px;
	font-family: var(--font-family-metropolis-semi-bold);
`;

export const ContainerBlur = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const Blur = styled.div`
	filter: blur(1px) !important;
`;

export const BoxLogin = styled.div`
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: center;
	flex-wrap: wrap;

	@media only screen and (max-width: 900px) {
		width: 7rem;
		justify-content: flex-start;
	}

	.btn-fb {
		@media only screen and (max-width: 900px) {
			width: 3.188rem;
		}
		background-color: #1877f2;
		width: 13rem;
		height: 2.5rem;
		border: #1877f2;
		border-radius: 8px;
		outline: none !important;
		background-image: url(${facebook});
		background-repeat: no-repeat;
		background-position: center;

		&:hover {
			background-image: url(${facebook});
			background-color: #0f64d1;
		}
	}

	.btn-google {
		@media only screen and (max-width: 900px) {
			width: 3.188rem !important;
		}
		width: 13rem !important;
		height: 2.5rem;
		border-radius: 8px !important;
		outline: none !important;
		background-image: url(${google});
		background-repeat: no-repeat;
		background-position: center;
	}
`;

export const BoxQRcode = styled.div`
	margin-top: 3.5rem;
	font-size: 16px;
	text-align: center;
	width: 100%;

	button {
		background: transparent;
		border: 0;
		color: #01e59b;
		text-decoration: none;
		font-size: 16px;
		font-family: var(--font-family-metropolis-semi-bold);
		outline: none !important;

		&.centered {
			display: flex;
			justify-content: center;
		}

		&:hover {
			color: #01e59b;
			text-decoration: underline;
		}
	}

	@media only screen and (max-width: 900px) {
		display: none;
	}
`;

export const MessageError = styled.span`
	color: #d30d48;
	font-family: var(--font-family-metropolis-semi-bold);
	font-size: 12px;
`;

export const ContainerButton = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
`;
